import { Link, Text, Box, Heading, Flex, useDisclosure } from "@chakra-ui/react";
import query_tool from './images/querytool.png';
import UserGuide from './images/UserGuide.png';
import ReleaseNotes from './images/ReleaseNotes.png';
import DescriptionCardWP from "./DescriptionCardWP";
import ReleasesModal from './ReleasesModal';
import { useNavigate } from "react-router-dom";
import { HiMiniListBullet } from "react-icons/hi2";
import { MdOutlineEmail } from "react-icons/md";
import { Icon } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

export default function InfoPage() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const navigate = useNavigate(); // Hook for routing
  const { t } = useTranslation();

  return (
    <Box h="100%" w="100%" bgColor="#f6f3ec" overflowY="auto">
      <Box h="10%" w="100%" paddingLeft="10px">
        <Heading fontFamily="inherit" fontWeight="bold" color={"rgba(11,78,90,255)"}>
          AMELIA - {t('infoPage.infoDescription')}
        </Heading>
      </Box>

      {/* <Box
        display="flex"
        w="98%"
        marginLeft={"1%"}
        marginRight={"1%"}
      > */}

      <Box display="flex" w="100%">
        {/* Text Box */}
        <Box flex={1} bg="#b4dbdb" color="#003b47" p={5} borderRadius="lg" margin={"2%"} maxHeight="180px" mt={0}>
          <Flex justify="space-between" mb={8}>
            <Box maxW="95%">
              <Heading as="h2" fontSize="3xl" mb={4}>
                {t('infoPage.news')}
              </Heading>
              {/* Icon and Text Container */}
              <Flex align="flex-start">
                <Icon
                  as={HiMiniListBullet}
                  color="black"
                  boxSize={6}
                  ml={3}
                  mr={3} // Add spacing between icon and text
                  css={{
                    ':hover': {
                      color: 'currentColor',
                    },
                  }}
                />
                <Text fontSize="lg">
                  {t('infoPage.newsDescription')}
                </Text>
              </Flex>
            </Box>
          </Flex>
        </Box>
      </Box>
      {/* Fine Text Box */}



      <Flex w="100%" gap={2} mt={-3}>
        {/* First DescriptionCard */}
        <Box flex={1} marginLeft={"2%"}>
          <DescriptionCardWP
            title={["AMELIA " + t('infoPage.releases')]}
            description={t('infoPage.releasesDescription')}
            ImgUrl={ReleaseNotes}
            textButton={t('infoPage.learnMore')}
            onClick={onOpen} // Opens the modal
            height="300px"
          />
        </Box>

        {/* Second DescriptionCard */}
        <Box flex={1} marginRight={"2%"} w="50%">
          <DescriptionCardWP
            title={["AMELIA " + t('infoPage.userGuides')]}
            description={t('infoPage.userGuidesDescription')}
            ImgUrl={UserGuide}
            textButton={t('infoPage.learnMore')}
            onClick={() => navigate("/userguide?hideHeader=true&hideNavbar=true")} // Navigates to the User Guide page
            height="300px"
          />
        </Box>
      </Flex>

      {/* ReleasesModal */}
      <ReleasesModal isOpen={isOpen} onClose={onClose} />
      {/* Support Area */}
      <Box flex={1} bg="#b4dbdb" color="#003b47" p={5} borderRadius="lg" margin="2%" maxHeight="60px" mt={3} mb={0}>
        <Box display="flex" flexDirection="column" justifyContent="flex-start" height="100%" alignItems="flex-start">
          <Heading as="h2" fontSize="xl" mb={0} mt={-4}>
            {t('infoPage.support')}
          </Heading>
          <Flex alignItems="center" mt={0} pl={2}>
            <Icon
              as={MdOutlineEmail}
              color="black"
              boxSize={6}
              mr={3}
              css={{
                ':hover': {
                  color: 'currentColor',
                },
              }}
            />
            <Text fontSize="lg" mt={1}>
              {t('infoPage.supportAssistance')}
              {/* For Assistance contact us:{" "} */}
              <Link href="mailto:grins.supportotecnico@exprivia.com" color="blue.500">
                grins.supportotecnico@exprivia.com
              </Link>
            </Text>
          </Flex>
        </Box>
      </Box>


      {/* Fine Support Area */}
    </Box>
  );
}
